<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm">
  <!-- FlowTemplate -->
  <div class="flex flex-col">
    <mat-radio-group class="radio-group" formControlName="oicFilterOptions" [(ngModel)]="selectedFilterOption">
      <mat-radio-button *ngFor="let filterOption of oicReturnFilterOptions" [value]="filterOption.key">
        {{filterOption.value}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</form>
